import React from 'react';
import { TextField, Grid, Box,Divider,Typography,Switch  } from '@mui/material';
import { callApi } from '../../../utils/apiClient';
import { API_ENDPOINTS } from '../../../config/api/apiCall';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import WHLocationTypeActionMenu from './WHLocationTypeActionMenu';
import { Warehouse_API_ENDPOINTS } from '../../../config/api/apiCallWarehouse';

const WHAddUpdateLocationType = ({ locationFormData, setLocationFormData, setIsFormOpen, LoadLocationList }) => {
  const isEdit = !!(locationFormData?.location_type_id && locationFormData.location_type_id !== 0);
const ltypeid=locationFormData.location_type_id||0;

//toast.dismiss();

React.useEffect(() => {
  if (!locationFormData || locationFormData.location_type_id === 0) {
    setLocationFormData((prev) => ({ ...prev, status: true }));
  }
}, []);

 const handleSave = async () => {
  if (!locationFormData.code?.trim()) {
    alert('Please enter Warehouse Location Type Code.');
    return;
  }
  if (!locationFormData.description?.trim()) {
    alert('Please enter Warehouse Location Type Description.');
    return;
  }

  const isEdit = ltypeid > 0;

  const payload = {
    p_id: ltypeid,
    p_code: locationFormData.code,
    p_description: locationFormData.description,
    p_company_id: localStorage.getItem('companyid'),
    p_plant_id: 1,
    p_created_by: 100,
    p_updated_by: 100,
    p_status: locationFormData.status,
  };

  const endpoint = isEdit
    ? Warehouse_API_ENDPOINTS.locationType.update
    : Warehouse_API_ENDPOINTS.locationType.create;

  try {
    const response = await callApi(
      endpoint,
      'POST',
      { 'Content-Type': 'application/json' },
      payload
    );

   const message =
      response[0]?.message ||       // fallback if API returns plain object
       "Location Type saved successfully!";
   //showAlert(message);
       toast.success(message, {
         position: toast.POSITION.BOTTOM_CENTER,
         autoClose: 2000,
       });

    // ✅ Reload list and find the newly created record
     LoadLocationList();

    if (!isEdit && response && response[0]?.location_type_id) {
          setLocationFormData({
            location_type_id: response[0].location_type_id,
            code: locationFormData.code,
            description: locationFormData.description,
            status: locationFormData.status,
          });
        } else {
          // For updates, just ensure data stays in edit mode
          setLocationFormData((prev) => ({
            ...prev,
            location_type_id: ltypeid,
          }));
        }
    
      } catch (error) {
        console.error('Error saving warehouse type:', error);
        toast.error("Failed to save Warehouse Type", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 2000,
        });
      }
    };


  const handleDelete = async () => {
    if (!isEdit) return;

    const confirmed = window.confirm('Are you sure you want to delete this Location Type?');
    if (!confirmed) return; // ❌ Stop if user cancels

    try {
      const payload = {
        p_id: ltypeid,
         p_code: locationFormData.code,
        p_description: locationFormData.description,
        p_company_id: localStorage.getItem('companyid'),
        p_plant_id: 1,
        p_updated_by: 100,
        //p_status:locationFormData.status,
      };

      await callApi(
        Warehouse_API_ENDPOINTS.locationType.delete,
        'POST',
        { 'Content-Type': 'application/json' },
        payload
      );
//  toast.success("Location Type deleted successfully!",{ position: toast.POSITION.BOTTOM_CENTER },{autoclose:60000});
      toast.success("Location Type deleted successfully!", {
  position: "bottom-center",
  autoClose:2000,
});
       LoadLocationList();
      setLocationFormData({
      location_type_id: 0, // reset to 0 → Add mode
      code: '',
      description: '',
      status:true,
    });
      // setIsFormOpen(false);
    } catch (error) {
      console.error('Error deleting location type:', error);
    }
  };
 const handleClear = () => {
    setLocationFormData({
      location_type_id: 0, // reset to 0 → Add mode
      code: '',
      description: '',
      status:true,
    });
  };
const handleExit = () => setIsFormOpen(false);
 
  return (
    <Box fullWidth>
      {/* 🔹 Header / Action Menu */}
      <WHLocationTypeActionMenu
        isEdit={isEdit}
        onSave={handleSave}
        onDelete={handleDelete}
        onClear={handleClear}
        onExit={handleExit}
        saveDisabled={!locationFormData.code || !locationFormData.description}
      />

      <Divider />

      {/* 🔹 Form Section */}
      <Box p={3}>
        <Grid container spacing={3}>
          {/* 🔸 CODE ROW */}
          <Grid item xs={12}>
            <Box
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(2, 1fr)',
                sm: 'repeat(12, 1fr)',
              }}
              gap={{ xs: '20px', sm: '10px' }}
              alignItems="center"
            >
              <Box gridColumn="span 2">
                <Typography
                  variant="h6"
                  sx={{ color: '#fff', fontSize: 14, fontWeight: 600 }}
                >
                  Code
                </Typography>
              </Box>

              <Box gridColumn="span 5">
                <TextField
                  fullWidth
                  size="small"
                  color="secondary"
                  placeholder="Enter Location Type Code"
                  value={locationFormData.code || ''}
                  onChange={(e) =>
                    setLocationFormData({
                      ...locationFormData,
                      code: e.target.value.toUpperCase(),
                    })
                  }
                  inputProps={{ style: { color: '#fff' } }}
                  disabled={isEdit}
                />
              </Box>
            </Box>
          </Grid>

          {/* 🔸 DESCRIPTION ROW */}
          <Grid item xs={12}>
            <Box
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(2, 1fr)',
                sm: 'repeat(12, 1fr)',
              }}
              gap={{ xs: '20px', sm: '10px' }}
              alignItems="center"
            >
              <Box gridColumn="span 2">
                <Typography
                  variant="h6"
                  sx={{ color: '#fff', fontSize: 14, fontWeight: 600 }}
                >
                  Description
                </Typography>
              </Box>

              <Box gridColumn="span 5">
                <TextField
                  fullWidth
                  size="small"
                  color="secondary"
                  placeholder="Enter Description"
                  value={locationFormData.description || ''}
                  onChange={(e) =>
                    setLocationFormData({
                      ...locationFormData,
                      description: e.target.value.toUpperCase(),
                    })
                  }
                  inputProps={{ style: { color: '#fff' } }}
                />
              </Box>
            </Box>
          </Grid>
           {/* STATUS ROW */}
                              <Grid item xs={12}>
                                <Box
                                  display="grid"
                                  gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(12, 1fr)',
                                  }}
                                  gap={{ xs: '20px', sm: '10px' }}
                                  alignItems="center"
                                >
                                  <Box gridColumn="span 2">
                                    <Typography variant="h6">Status</Typography>
                                  </Box>
                                  <Box gridColumn="span 5" display="flex" alignItems="center" gap={1}>
  <Switch
    checked={locationFormData.status === undefined ? true : locationFormData.status}
    color="secondary"
    onChange={(e) =>
      setLocationFormData({
        ...locationFormData,
        status: e.target.checked,
      })
    }
  />
  <Typography>
    {locationFormData.status === undefined
      ? "Active"
      : locationFormData.status
      ? "Active"
      : "Inactive"}
  </Typography>
</Box>
                                </Box>
                              </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default WHAddUpdateLocationType;
